import { Box, Typography } from "@mui/material";
import {
  type HunterSearchDto,
  LicensePaymentStatus,
} from "Infrastructure/Api/Api";
import type { HTMLAttributes } from "react";

export const getHunterDisplayName = ({
  companyName,
  firstName,
  lastName,
}: HunterSearchDto) =>
  companyName ?? `${firstName ?? ""} ${lastName ?? ""}`.trim();

export const getHunterOptionLabel = (option: HunterSearchDto) => {
  const name = getHunterDisplayName(option);
  return option.licenseNo ? `${name} | No. ${option.licenseNo}` : name;
};

export const isHunterOptionEqualToValue = (
  option: HunterSearchDto,
  value: HunterSearchDto,
) =>
  option.partyPublicID === value.partyPublicID &&
  option.licensePublicID === value.licensePublicID;

export const isHunterLicenseInactive = ({
  licensePaymentStatus,
}: HunterSearchDto) => licensePaymentStatus !== LicensePaymentStatus.Success;

export const sortHuntersByLicenseActivity = (
  hunters: ReadonlyArray<HunterSearchDto>,
): Array<HunterSearchDto> =>
  [...hunters].sort(
    (a, b) =>
      Number(isHunterLicenseInactive(a)) - Number(isHunterLicenseInactive(b)),
  );

type LiProps = HTMLAttributes<HTMLLIElement> & { id?: string };

export const renderHunterOption = (props: LiProps, option: HunterSearchDto) => (
  <Box component="li" {...props} key={props.id} display="flex" gap={1}>
    <Typography variant="body2">{getHunterDisplayName(option)}</Typography>
    {option.licenseNo && (
      <Box component="span" display="flex" gap={1}>
        <Typography variant="body2">|</Typography>
        <Typography variant="caption" color="text.secondary">
          No. {option.licenseNo}
        </Typography>
      </Box>
    )}
  </Box>
);
